import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';

const SrTextSeparator = ({ text }) => {
  return (
    <SrBox margin='18px 0 0 0'>
      <SrFlex align='center' justify='center'>
        <SrBox width='100%' height='1px' backgroundColor='rgba(123, 132, 136, 0.12)' />
        <SrBox margin='0 14px'>
          <SrText
            color='blue'
            font='greycliff'
            fontSize='13px'
            lineHeight='16px'
            opacity='0.5'
            weight='600'
            align='center'
            letterSpacing='0.41px'
          >
            { text }
          </SrText>
        </SrBox>
        <SrBox width='100%' height='1px' backgroundColor='rgba(123, 132, 136, 0.12)' />
      </SrFlex>
    </SrBox>
  );
};

SrTextSeparator.propTypes = {
  text: PropTypes.string,
};

SrTextSeparator.defaultProps = {
  text: 'or',
};

SrTextSeparator.displayName = 'SrTextSeparator';

export default SrTextSeparator;
